import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
/**
 *
 * @param {any[]} providers
 * @returns {Workbook}
 */
export const exportExcel = async (providers) => {
  providers.forEach((provider, index) => (provider.order = index + 1));

  const json = excelHelper.jsonToJson(
    [providers],
    [
      {
        name: "PROVEEDORES",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "code",
            outValue: "CODIGO",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "ruc",
            outValue: "RUC",
          },
          {
            inValue: "phone",
            outValue: "NUMERO TELEFONICO",
          },
          {
            inValue: "email",
            outValue: "CORREO ELECTRONICO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName();
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = () => {
  return (
    formatHelper.toDateYYMMDD(new Date().toUTCString()) +
    "_reporte-general-proveedores.xlsx"
  );
};



// WEBPACK FOOTER //
// ./src/scenes/Administration/Provider/ProviderList/excel.js